import { render, staticRenderFns } from "./RankingInfoBox.vue?vue&type=template&id=1ba3cb2e&scoped=true"
import script from "./RankingInfoBox.vue?vue&type=script&lang=js"
export * from "./RankingInfoBox.vue?vue&type=script&lang=js"
import style0 from "./RankingInfoBox.vue?vue&type=style&index=0&id=1ba3cb2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba3cb2e",
  null
  
)

export default component.exports